import * as React from 'react';
import RoutePrivate from 'src/components/router/RoutePrivate';
import DepositsRecPage from './DepositReconciliationComponent';
import ArPastDueComponent from './ArPastDueComponent';
import ArHistoryComponent from './ArHistoryComponent';
import IccoBreakdownComponent from './IccoBreakdownComponent';

export default function getRoutes(isLoggedIn: boolean) {
    return [
        <RoutePrivate key="deposit-invoice-reconciliation" path="/accounts-receivable/deposit-invoice-reconciliation" component={DepositsRecPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="past-due-invoices" path="/accounts-receivable/past-due-invoices" component={ArPastDueComponent} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="ar-history" path="/accounts-receivable/history" component={ArHistoryComponent} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="icco-breakdown" path="/accounts-receivable/icco-breakdown" component={IccoBreakdownComponent} isLoggedIn={isLoggedIn} />,
    ];
}



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/AR.Routes.tsx